import * as React from "react";
const CalendarSVGEvent = () => (
  <svg
    fill="#fff"
    width="20px"
    height="20px"
    viewBox="0 0 512 512"
  >
    <path d="M96 416Q82 416 73 407 64 398 64 384L64 136Q64 122 73 113 82 104 96 104L112 104 112 64 160 64 160 104 232 104 232 64 280 64 280 104 352 104 352 64 400 64 400 104 416 104Q430 104 439 113 448 122 448 136L448 384Q448 398 439 407 430 416 416 416L96 416ZM400 368L400 208 112 208 112 368 400 368Z" />
  </svg>
);
export default CalendarSVGEvent;
